var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAppLayout',[_c('VAppMain',[_c('VGridPageColumn',{attrs:{"col-12":""}},[_c('VGridRow',{staticClass:"grid_fluid grid_center"},[_c('ErrorViewer',{attrs:{"status":"404"}},[_vm._v(" Запрашиваемая страница "),_c('br'),_vm._v("не найдена. ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }